// Details for additional maps, including ESRI, are provided at
// https://leaflet-extras.github.io/leaflet-providers/preview/

export interface BasemapDefault {
  id: string,
  url: string,
  attribution: string,
  subdomains?: string
  minZoom?: number,
  maxZoom?: number,
}

export const OpenStreetMapMapnikID = 'OpenStreetMap.Mapnik'

export const OpenStreetMapMapnik: BasemapDefault = {
  id: OpenStreetMapMapnikID,
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  maxZoom: 19,
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
} as const

export const OpenTopoMapID = 'OpenTopoMap'

export const OpenTopoMap: BasemapDefault = {
  id: OpenTopoMapID,
  url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
  maxZoom: 17,
  attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
} as const

export const StamenWatercolorID = 'Stamen.Watercolor'

export const StamenWatercolor: BasemapDefault = {
  id: StamenWatercolorID,
  url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg',
  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  subdomains: 'abcd',
  minZoom: 1,
  maxZoom: 16,
} as const

export const StamenTerrainID = 'Stamen.Terrain'

export const StamenTerrain: BasemapDefault = {
  id: StamenTerrainID,
  url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png',
  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  subdomains: 'abcd',
  minZoom: 0,
  maxZoom: 18,
} as const

export const StamenTerrainBackgroundID = 'Stamen.TerrainBackground'

export const StamenTerrainBackground: BasemapDefault = {
  id: StamenTerrainBackgroundID,
  url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}{r}.png',
  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  subdomains: 'abcd',
  minZoom: 0,
  maxZoom: 18,
} as const

export const defaultMaps = [
  OpenStreetMapMapnik,
  OpenTopoMap,
  StamenWatercolor,
  StamenTerrain,
  StamenTerrainBackground,
] as const

// Match the IDS within defaultMaps!
export const DefaultMapIDs = [
  OpenStreetMapMapnikID,
  OpenTopoMapID,
  StamenWatercolorID,
  StamenTerrainID,
  StamenTerrainBackgroundID,
] as const

export type DefaultBasemap = typeof DefaultMapIDs[number]

export function isBasemapDefault (basemap: string) {
  return defaultMaps.some((defaultMap: BasemapDefault) => defaultMap.id === basemap)
}

export default defaultMaps
